import React from 'react';
import styled from 'styled-components';
import { GoogleApiWrapper, Map, Marker } from 'google-maps-react';
import Backdrop from '@material-ui/core/Backdrop';
const GoogleMap = (props) => {
    const { lat, lng, disabled, draggable = true, onDragEnd = () => { }, google } = props;
    return (React.createElement("div", { style: { position: 'relative' } },
        React.createElement(Map, { google: google, zoom: 16, center: { lat, lng }, initialCenter: { lat, lng }, containerStyle: { position: 'relative', width: '100%', height: '300px' }, mapTypeControl: false, streetViewControl: false, fullscreenControl: false },
            React.createElement(Marker, { position: { lat, lng }, draggable: draggable, onDragend: (_t, _map, coord) => onDragEnd(coord.latLng.lat, coord.latLng.lng) })),
        React.createElement(SBackdrop, { open: disabled },
            React.createElement("p", null, "\u4F4F\u6240\u304B\u3089\u5730\u56F3\u3092\u78BA\u8A8D \u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044"))));
};
const SBackdrop = styled(Backdrop) `
  &&& {
    z-index: 1000;
    position: absolute;
    top: 0;
    width: 100%;
    height: 300px;
    color: #fff;
  }
`;
export default GoogleApiWrapper({
    apiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    language: 'ja',
})(GoogleMap);
